import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import LandingPage from "./components/LandingPage";
import AnalysisPage from "./components/AnalysisPage";
import JobList from "./components/JobList";
import ViewAnalysis from "./components/ViewAnalysis";

const App = () => {
    return (
        <Router>
            <Routes>
                <Route path="/" element={<LandingPage />} />
                <Route path="/analysis" element={<AnalysisPage />} />
                <Route path="/jobs" element={<JobList />} />
                <Route path="/view-analysis/:jobId" element={<ViewAnalysis />} />
            </Routes>
        </Router>
    );
};

export default App;